export default __webpack_public_path__ + "static/media/img-slider-banpu-power-3.ddc27d1e.png";